import OpenInFullIcon from "@mui/icons-material/OpenInFullRounded";
import { Dialog, DialogContent, IconButton, Paper, Stack, Tooltip } from "@mui/material";
import { useState, type PropsWithChildren, type ReactNode } from "react";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";

interface Props {
  withFixedHeight?: boolean;
  fitContent?: boolean;
  withFullScreenButton?: boolean;
  actions?: ReactNode;
}

const getFlex = (withFixedHeight: boolean | undefined, fitContent: boolean | undefined) => {
  if (fitContent) {
    return "0 0 auto";
  }
  return withFixedHeight ? "0 0 500px" : 1;
};

const WidgetCardWrapper = ({
  withFixedHeight,
  fitContent,
  withFullScreenButton,
  actions,
  children,
}: PropsWithChildren<Props>) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  if (isFullScreen) {
    return (
      <Dialog
        open
        onClose={() => setIsFullScreen(false)}
        fullScreen
        sx={{ m: 2 }}
        slotProps={{ paper: { sx: { borderRadius: 1 } } }}
      >
        <DialogCloseButton onClick={() => setIsFullScreen(false)} />
        <DialogContent sx={{ minHeight: 0, display: "flex", flexDirection: "column" }}>{children}</DialogContent>
      </Dialog>
    );
  }

  return (
    <Paper
      variant="outlined"
      sx={{
        flex: getFlex(withFixedHeight, fitContent),
        p: 2,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
    >
      <Stack direction="row" spacing={1} sx={{ position: "absolute", top: 16, right: 8, alignItems: "center" }}>
        {actions}
        {withFullScreenButton && (
          <Tooltip arrow title="Open in full screen" placement="bottom">
            <IconButton aria-label="Open in full screen" onClick={() => setIsFullScreen(true)}>
              <OpenInFullIcon />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
      {children}
    </Paper>
  );
};

export default WidgetCardWrapper;
